import { call, cancelled, put, take, takeLatest } from "redux-saga/effects";
import {
  uploadProgress,
  uploadSuccess,
  uploadFailure,
} from "../slices/uploadSlice";
import UploadService from "../../services/UploadService";
import { eventChannel, END } from "redux-saga";

function createUploadProgressChannel({ file, type }) {
  return eventChannel((emitter) => {
    // Call the service with the file and progress callback
    UploadService.upload(file, type, (progress) => {
      emitter({ progress }); // Emit progress updates
    })
      .then((response) => {
        emitter({ success: true, data: response.data }); // Emit success when server returns 200 OK
        emitter(END); // Close the channel after success
      })
      .catch((error) => {
        emitter({ error: error.message }); // Emit error if upload fails
        emitter(END); // Close the channel on error
      });

    // The subscriber must return an unsubscribe function
    return () => {};
  });
}

function* handleFileUpload(action) {
  const file = action.payload.file.name;
  const progressChannel = yield call(
    createUploadProgressChannel,
    action.payload
  );

  try {
    while (true) {
      const ajax = yield take(progressChannel);
      const { progress, success, error, data } = ajax;

      if (progress !== undefined) {
        yield put(uploadProgress({ file, progress })); // Dispatch progress updates
      }

      if (success) {
        const response =
          typeof data === "string"
            ? JSON.parse(data.replaceAll('{"response":"please wait"}', ""))
            : data;

        yield put(uploadSuccess({ file, response: { ...response.response } })); // Dispatch success when the server returns 200 OK
        break; // Break out of the loop and close the channel
      }

      if (error) {
        yield put(
          uploadFailure({
            status: error.includes("413") ? 413 : 400,
            file,
            response: "SOMETHING_ELSE_WRONG",
            ...(error?.response?.data || {}),
          })
        ); // Dispatch failure if there's an error
        break; // Break out of the loop and close the channel
      }
    }
  } catch (error) {
    yield put(
      uploadFailure({
        status: 400,
        file,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    ); // Handle any other errors
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

export default function* watchUploadSaga() {
  yield takeLatest("uploads/uploadRequest", handleFileUpload);
}
